import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { createInventoryInwardsLog } from '@/api/inventory-inwards-logs';
import { AppModule } from '@/store/modules/app';
import { TagsViewModule } from '@/store/modules/tags-view';
import { Action } from 'vuex-module-decorators';
let default_1 = class default_1 extends Vue {
  constructor() {
    super(...arguments);
    this.formData = {};
    this.loading = false;
    this.rules = {
      quantity: {
        required: true,
        message: 'This field is required',
        trigger: 'blur'
      },
      comments: {
        required: true,
        message: 'This field is required',
        trigger: 'blur'
      }
    };
  }
  get lang() {
    return AppModule.language;
  }
  created() {
    this.formData = {
      unitId: this.data.unit_id,
      productId: this.data.product_id,
      productsVariationId: this.data.productsVariation_id,
      action: 'outward',
      quantity: 0
    };
    this.tempTagView = Object.assign({}, this.$route);
  }
  setTagsViewTitle(title) {
    const tagView = this.tempTagView;
    if (tagView) {
      tagView.title = `${title}-${this.formData.id}`;
      TagsViewModule.updateVisitedView(tagView);
    }
  }
  setPageTitle(title) {
    document.title = `${title} - ${this.formData.id}`;
  }
  submitForm() {
    this.$refs.formData.validate(valid => {
      if (valid) {
        this.saveForm();
      } else {
        return false;
      }
    });
  }
  async saveForm() {
    try {
      this.loading = true;
      await createInventoryInwardsLog(this.formData);
      this.$notify({
        title: 'Success',
        message: 'Inventory updated',
        type: 'success',
        duration: 2000
      });
      this.loading = false;
      this.$emit('form-submit', true);
    } catch (err) {
      this.loading = false;
    }
  }
};
__decorate([Prop({
  default: null
})], default_1.prototype, "data", void 0);
__decorate([Prop({
  default: true
})], default_1.prototype, "dialogVisible", void 0);
__decorate([Action], default_1.prototype, "saveForm", null);
default_1 = __decorate([Component({
  name: 'InventoryRemove',
  components: {}
})], default_1);
export default default_1;